import { render, staticRenderFns } from "./ReferenceFiltersHeader.vue?vue&type=template&id=26729b0e&scoped=true&"
import script from "./ReferenceFiltersHeader.vue?vue&type=script&lang=js&"
export * from "./ReferenceFiltersHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceFiltersHeader.vue?vue&type=style&index=0&id=26729b0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26729b0e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VIcon})
